{
  "key": "bay-bowls-club",
  "title": "Bay Bowls Club green",
  "suburb": "Coolamon Bay",
  "locationGroup": "clubs",
  "grassType": "couch",
  "cellM": 0.25,
  "w": 56,
  "h": 62,
  "rows": [
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "eppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "eppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "eppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "eppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "eppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "eppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "eppppppppooooooppppppooooooppppppooooooppppppppppppppppe",
    "eppppppppppppppppppppppppppppppppppppppppppppppppppppppe",
    "ebbbbppppppppppppppppppppppppppppppppppppppppppppppbbbbe",
    "ebbbbppppppppppppppppppppppppppppppppppppppppppppppbbbbe",
    "ebbbbppppppppppppppppppppppppppppppppppppppppppppppbbbbe",
    "ebbbbppeeeeeeeeeeeeeeeeeeeppppeeeeeeeeeeeeeeeeeeeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeggggggggggggggggggggggggggggggggggggggggeppbbbbe",
    "ebbbbppeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeppbbbbe",
    "ebbbbppppppppppppppppppppppppppppppppppppppppppppppbbbbe",
    "ebbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbe",
    "ebbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbe",
    "ebbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbe",
    "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
  ],
  "zoneRows": [
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG........",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................",
    "........................................................"
  ],
  "zones": [
    {"id":"green","rangeMm":[4,6],"deckStepMm":2}
  ],
  "rangeMm": [4,6],
  "startLengthMm": [9,14],
  "props": [
    {"id":"verandah-1","kind":"verandah","x":7,"y":2,"w":13,"h":2,"solid":false},
    {"id":"bench-1","kind":"bench","x":3,"y":2.6,"w":1.6,"h":0.45,"solid":true},
    {"id":"bench-2","kind":"bench","x":6,"y":2.6,"w":1.6,"h":0.45,"solid":true},
    {"id":"bench-3","kind":"bench","x":9,"y":2.6,"w":1.6,"h":0.45,"solid":true},
    {"id":"bench-4","kind":"bench","x":1.6,"y":12,"w":0.45,"h":1.6,"solid":true},
    {"id":"flower-bed-1","kind":"flower-bed","x":0.75,"y":9.5,"w":1,"h":3.75,"solid":false},
    {"id":"flower-bed-2","kind":"flower-bed","x":13.25,"y":9.5,"w":1,"h":3.75,"solid":false},
    {"id":"flower-bed-3","kind":"flower-bed","x":7,"y":14.75,"w":11.5,"h":0.75,"solid":false},
    {"id":"tap-1","kind":"tap","x":5.5,"y":3.2,"r":0.08,"solid":false},
    {"id":"gum-tree-1","kind":"gum-tree","x":12.9,"y":14.5,"r":0.35,"solid":true,"canopyR":2.8}
  ],
  "spawn": {"x":7,"y":3.25,"heading":1.5707963267948966},
  "utePark": {"x":1.5,"y":4,"heading":1.5707963267948966},
  "weedFraction": 0.02,
  "leaves": {"count":[40,90]},
  "camera": {"fit":"contain","allowLandscape":false},
  "mutations": ["sprinkler","magpie-season","heavy-leaves","ibis","hot-day"]
}
